import { ChannelConfigModel, EVENT_STATUS } from '../model/signal-r.model';

export class LastConnection {
	static readonly type = '[SignalR] Last Connection';
	constructor(public timestamp: number) {}
}

export class SaveConnectionID {
	static readonly type = '[SignalR] Save Connection ID';
	constructor(public connectionId: number) {}
}

export class SetOfflineConnection {
	static readonly type = '[SignalR] Set Offline Connection';
}

export class SetAvailabilityConnection {
	static readonly type = '[SignalR] Set Availability Connection';
	constructor(public enabled: boolean) {}
}

export class RegisterChannel {
	static readonly type = '[SignalR] Register a new Channel';
	constructor(public channelName: string, public channelConfigModel: ChannelConfigModel) {}
}

export class UnregisterChannel {
	static readonly type = '[SignalR] Unregister a Channel';
	constructor(public channelName: string) {}
}

export class RegisterEventChannelAction {
	static readonly type = '[SignalR] Register new Event to Channel';
	constructor(public channelName: string, public event: any) {}
}

export class RemoveEventChannelAction {
	static readonly type = '[SignalR] Remove an Event from the Channel';
	constructor(public channelName: string, public event: any, public parameter: string) {}
}

export class ChangeEventStatusChannelAction {
	static readonly type = '[SignalR] Change Status Event to a Channel';
	constructor(public channelName: string, public status: EVENT_STATUS) {}
}

export class ChangeEventItemOnChannelAction {
	static readonly type = '[SignalR] Change an Event item from a Channel';
	constructor(public channelName: string, public event: any, public parameter: string) {}
}
